// extracted by css-extract-rspack-plugin
export default {"hidden-form":"hidden-form-SpPXDT","hiddenForm":"hidden-form-SpPXDT","card-title":"card-title-slzbY3","cardTitle":"card-title-slzbY3","smallCharacters":"smallCharacters-qbnbKC"};